import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Link from "next/link";
import styles from "./ErrorModal.module.scss";
import useTranslation from "next-translate/useTranslation";

var ErrorModal = function ErrorModal(props) {
  var toggle = props.toggle,
      show = props.show,
      buttonLabel = props.buttonLabel,
      className = props.className,
      error = props.error,
      redirect = props.redirect;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var isRTL = lang === 'farsi';

  var getErrorMessage = function getErrorMessage(error) {
    switch (error) {
      case 'level':
        return "You didn't choose any level";

      case 'book':
        return "You didn't choose any book";

      case 'lesson':
        return "You didn't choose any lesson";

      case 'topic':
        return "You didn't choose any topic";

      case 'login':
        return 'You need to login first';

      case 'search':
        return "User not found.";
    }
  };

  var getErrorMessageFa = function getErrorMessageFa(error) {
    switch (error) {
      case 'level':
        return "شما هیچ مرحله‌ای انتخاب نکرده‌اید";

      case 'book':
        return "شما هیچ کتابی انتخاب نکرده‌اید";

      case 'lesson':
        return "شما هیچ درسی انتخاب نکرده‌اید";

      case 'topic':
        return "شما هیچ موضوعی انتخاب نکرده‌اید";

      case 'login':
        return 'شما باید اول وارد حساب کاربری خود شوید';

      case 'search':
        return "کاربری پیدا نشد";
    }
  };

  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsxs(Modal, {
      isOpen: show,
      toggle: toggle,
      className: className,
      style: {
        fontFamily: isRTL ? 'Yekan' : 'Helvetica'
      },
      children: [/*#__PURE__*/_jsx(ModalHeader, {
        toggle: toggle,
        children: isRTL ? 'خطا' : 'Error'
      }), /*#__PURE__*/_jsx(ModalBody, {
        children: /*#__PURE__*/_jsx("div", {
          className: styles.messageWrapper,
          style: {
            direction: isRTL ? 'rtl' : 'ltr'
          },
          children: error && (isRTL ? getErrorMessageFa(error[0]) : getErrorMessage(error[0]))
        })
      }), /*#__PURE__*/_jsxs(ModalFooter, {
        children: [error && error[0] === "login" && /*#__PURE__*/_jsx(Link, {
          href: {
            pathname: '/verifyPhone',
            query: {
              redirect: redirect
            }
          },
          children: /*#__PURE__*/_jsx("a", {
            className: "btn bg-primary ".concat(styles.loginBtn),
            children: isRTL ? 'ورود یا ثبت نام' : 'Login or Register'
          })
        }), /*#__PURE__*/_jsx(Button, {
          color: "danger",
          onClick: toggle,
          children: isRTL ? 'لغو' : 'Cancel'
        })]
      })]
    })
  });
};

export default ErrorModal;